if (!customElements.get('nap-collection-slider')) {
  customElements.define('nap-collection-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.butotn_list_group');
      this.cards = Array.from(this.track.children);
      this.clones = [];
      this.interacting = false;
      this.hovered = false;
      this.pauseUntil = 0;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal, passive: true };
      const pause = () => { this.pauseUntil = performance.now() + 1500; };
      this.track.addEventListener('pointerdown', () => { this.interacting = true; }, options);
      const release = () => {
        if (!this.interacting) return;
        this.interacting = false;
        pause();
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.track.addEventListener('wheel', pause, options);
      this.track.addEventListener('scroll', () => {
        if (performance.now() < this.pauseUntil) pause();
      }, options);
      this.track.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.hovered = true;
      }, options);
      this.track.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.hovered = false;
      }, options);
      this.onResize = () => this.configure();
      this.mobile.addEventListener('change', this.onResize);
      this.reducedMotion.addEventListener('change', this.onResize);
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this.track);
      this.configure();
    }

    configure() {
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      if (!this.mobile.matches || this.reducedMotion.matches) {
        this.clones.forEach(card => card.remove());
        this.clones = [];
        if (!this.mobile.matches) this.track.scrollLeft = 0;
        return;
      }
      if (!this.clones.length) {
        this.clones = this.cards.map(card => {
          const clone = card.cloneNode(true);
          clone.dataset.loopClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]')
            .forEach(element => { element.tabIndex = -1; });
          return clone;
        });
        this.track.append(...this.clones);
      }
      this.cycleWidth = this.clones[0].offsetLeft - this.cards[0].offsetLeft;
      if (!this.cycleWidth) return;
      this.position = this.track.scrollLeft % this.cycleWidth;
      this.frame = requestAnimationFrame(time => this.animate(time));
    }

    animate(time) {
      const elapsed = this.lastTime === null ? 0 : Math.min(time - this.lastTime, 64);
      this.lastTime = time;
      const paused = document.hidden || this.interacting || this.hovered ||
        this.contains(document.activeElement) || time < this.pauseUntil;
      if (paused) {
        this.position = this.track.scrollLeft % this.cycleWidth;
      } else {
        // Constant speed, with a seamless handoff from copies to the original tiles.
        this.position = (this.position + elapsed * 0.05) % this.cycleWidth;
        this.track.scrollLeft = this.position;
      }
      this.frame = requestAnimationFrame(nextTime => this.animate(nextTime));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.events?.abort();
      this.mobile?.removeEventListener('change', this.onResize);
      this.reducedMotion?.removeEventListener('change', this.onResize);
      this.clones?.forEach(card => card.remove());
    }
  });
}
